import { AxiosResponse } from "axios";
import { axiosConfig } from "../../config/api/configApi";
import { CoursePayload } from "../../types/course";
import { axiosConfigV2OpenAPI } from "../../config/api/configOpenApiV2";
import { axiosConfigV2 } from "../../config/api/configApiv2";

export const getCourseProgramList: (
  params: any
) => Promise<AxiosResponse<any>> = (params: any) => {
  return axiosConfigV2OpenAPI.post(`/curriculum/get-curriculum-by-filter`, params);
};

export const getCurriculumDetail: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfigV2OpenAPI.get(`/curriculum/${id}`);
};

export const getCurriculumRecommend: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfigV2OpenAPI.get(`/curriculum/get-curriculum-recommend/${id}`);
};

export const getCurriculumRoadmap: (
  id: number
) => Promise<AxiosResponse<any>> = (id: number) => {
  return axiosConfigV2OpenAPI.get(`/curriculum/get-curriculum-roadmap/${id}`);
};

export const getEnterprise: (flug: string) => Promise<AxiosResponse<any>> = (
  flug: string
) => {
  return axiosConfigV2OpenAPI.get(`/enterprise/get-enterprise/${flug}`);
};

export const getCourseInsights: (
  id: number,
  params: any
) => Promise<AxiosResponse<any>> = (id: number, params: any) => {
  return axiosConfigV2OpenAPI.get(`/comment/curriculum/${id}?${params}`);
};

export const getCurriculumReviewList: (
  id: number,
  params: any
) => Promise<AxiosResponse<any>> = (id: number, params: any) => {
  return axiosConfigV2OpenAPI.get(`/comment/curriculum/${id}?${params}`);
};

export const addCurriculumReview: (
  payload?: any
) => Promise<AxiosResponse<any>> = (payload = {}) => {
  return axiosConfigV2.post(`/curriculum-review/comment`, payload);
};

export const editCurriculumReview: (
  payload?: any
) => Promise<AxiosResponse<any>> = (payload = {}) => {
  return axiosConfigV2.put(`/curriculum-review/edit-comment`, payload);
};

export const deleteCurriculumReview: (
  data: any
) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.delete(`/curriculum-review/delete`, { data });
};

export const getCurriculumRating: (
  id?: number
) => Promise<AxiosResponse<any>> = (id) => {
  return axiosConfigV2OpenAPI.get(`/comment/curriculum/count?curriculum=${id}`);
};

export const exportCurriculumReview: (
  id: number,
  params: any
) => Promise<AxiosResponse<any>> = (id: number, payload: any) => {
  return axiosConfigV2OpenAPI.post(`/comment/curriculum/${id}/export-excel`, payload, {
    responseType: "arraybuffer",
  });
};

export const exportCurriculumPrograms: (
  payload?: any
) => Promise<AxiosResponse<any>> = (payload) => {
  return axiosConfigV2OpenAPI.post(`/curriculum/export-excel`, payload, {
    responseType: "arraybuffer",
  });
};

export const getIndustryCurriculum: (
  payload?: CoursePayload
) => Promise<AxiosResponse<any>> = (payload = {}) => {
  return axiosConfigV2OpenAPI.post(`/curriculum/get-industry-filter`, payload);
};

export const getUniversityCurriculum: (
  payload?: CoursePayload
) => Promise<AxiosResponse<any>> = (payload = {}) => {
  return axiosConfigV2OpenAPI.post(`/curriculum/get-university-filter`, payload);
};

